<template>
  <div class="data-entry w-100">
    <div v-if="showButtons === false" @click="showYesNo = true">
      Yes/No ?
    </div>

    <div v-if="isBusy && showButtons" class="text-center">
      <i class="far fa-spinner fa-spin"></i>
    </div>

    <div v-if="isBusy === false && showButtons">
      <ifac-switcher-btn-group
        :read-only="review.can.declareConflict === false"
        :value="review.conflict_of_interest"
        @switch="updateConflict"
      />
    </div>

    <b-modal v-model="modalShow"
             title="Declare a conflict of interest?"
             size="lg"
             ok-title="Yes, I am in conflict of interest for this Nomination"
             cancel-title="No, I continue filling the review"
             @ok="declareConflict(true)"
             @cancel="declareConflict(false)">
      If you declare a conflict of interest your review will be erased.
    </b-modal>
  </div>
</template>

<script>
import { IfacSwitcherBtnGroup, IfacEventBus } from '@ifac/ui';
import Reviews from '@/services/Api/Awards/Reviews';
import { mapMutations } from 'vuex';

export default {
  name: 'YesNoCellRenderer',
  components: { IfacSwitcherBtnGroup },
  data() {
    return {
      modalShow: false,
      showYesNo: false,
      isBusy: false,
    };
  },
  methods: {
    ...mapMutations({
      setReview: 'awardsReviews/setItem',
    }),

    updateConflict(value) {
      if (this.isBusy) {
        return;
      }

      // Show warning
      if (this.review.conflict_of_interest === false && value === true) {
        this.modalShow = true;
        return;
      }

      if (value === this.review.conflict_of_interest) {
        return;
      }

      this.declareConflict(value);
    },
    declareConflict(value) {
      const params = {
        conflict: value,
      };

      this.isBusy = true;

      Reviews.declareConflict(this.review.id, params)
        .then((response) => {
          IfacEventBus.$emit('updateConflict', response.data.data);
          this.setReview(response.data.data);
        })
        .catch((error) => {
          this.setReview(this.review);

          this.$snack.success({
            text: error?.response.data.error.message,
          });
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
  },
  computed: {
    review() {
      return this.params.getValue();
    },
    showButtons() {
      return this.review.conflict_of_interest !== null || this.showYesNo;
    },
  },
};
</script>
